import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75fb5bb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-screen overflow-hidden blurred-bg" }
const _hoisted_2 = { class: "m-auto z-10 w-full px-2 sm:px-0 sm:w-auto text-center" }
const _hoisted_3 = { class: "appFont text-3xl sm:text-5xl text-center" }
const _hoisted_4 = { class: "premium-text-gradient" }
const _hoisted_5 = { class: "mt-5" }
const _hoisted_6 = { class: "text-center appFont text-xl" }
const _hoisted_7 = { class: "uppercase text-green-300" }
const _hoisted_8 = { class: "cursor-pointer" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-200" }, "KÉSZEN", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-green-200" }, "MOST", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-200" }, "READY", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-green-200" }, "NOW", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PremiumIcon = _resolveComponent("PremiumIcon")!
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_Layout = _resolveComponent("Layout")!
  const _component_WhatIGetSheet = _resolveComponent("WhatIGetSheet")!
  const _component_PurchaseSheet = _resolveComponent("PurchaseSheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Layout, { disableTopNav: true }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, [
              _createVNode(_component_PremiumIcon, { class: "colorChangeSvg" }),
              _createTextVNode(" "),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Premium')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('subscription')), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.$t('Support our development team and unlock a')) + " ", 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('lot of')), 1),
                _createTextVNode(),
                _createVNode(_component_Tippy, {
                  content: _ctx.$t('Just cool, there\'s nothing more to say') + ' 🤷🏼‍♂️😎'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('cool')), 1)
                  ]),
                  _: 1
                }, 8, ["content"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('feature')), 1)
              ]),
              (_ctx.$i18n.locale == 'hu')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sheets.purchase = true)),
                    shrink: "",
                    class: "transition duration-150 !text-white mt-3 bg-gradient-to-r from-indigo-500 via-purple-400 to-pink-500 hover:opacity-80 focus:opacity-60 block appFont rounded-lg px-3 py-2 w-full md:w-1/2 mx-auto text-center"
                  }, [
                    _hoisted_9,
                    _createTextVNode(" állok a frissítésre "),
                    _hoisted_10
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sheets.purchase = true)),
                    shrink: "",
                    class: "transition duration-150 !text-white mt-3 bg-gradient-to-r from-indigo-500 via-purple-400 to-pink-500 hover:opacity-80 focus:opacity-60 block appFont rounded-lg px-3 py-2 w-full md:w-1/2 mx-auto text-center"
                  }, [
                    _createTextVNode(" I'm "),
                    _hoisted_11,
                    _createTextVNode(" to upgrade "),
                    _hoisted_12
                  ])),
              _createElementVNode("button", {
                class: "mt-3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sheets.whatIGet = true))
              }, _toDisplayString(_ctx.$t('What do I get when I subscribe?')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_WhatIGetSheet, {
      onBuy: _cache[3] || (_cache[3] = ($event: any) => {_ctx.sheets.whatIGet = false;_ctx.sheets.purchase = true}),
      showSheet: _ctx.sheets.whatIGet,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sheets.whatIGet = false))
    }, null, 8, ["showSheet"]),
    _createVNode(_component_PurchaseSheet, {
      onWhySub: _cache[5] || (_cache[5] = ($event: any) => {_ctx.sheets.purchase = false;_ctx.sheets.whatIGet = true}),
      showSheet: _ctx.sheets.purchase,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sheets.purchase = false))
    }, null, 8, ["showSheet"])
  ], 64))
}